module.exports = "/_next/static/images/edf354af92ae3b666303c814e45f6fed-boy-looking-to-the-front-xs@2x.jpg.webp";